import PropTypes from 'prop-types'

export const bookingType = PropTypes.shape({
  loading: PropTypes.bool,
  error: PropTypes.shape(),
})

export const bookingDefaultProps = {}
